/** @format */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
	homefieldIconChevronRight,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconToolStraighten
} from '@dsg-tech/homefield-angular-icons';

import { HmfAccordionComponent } from '@dsg-tech/homefield-angular';
import { BypassSanitizationPipe } from '@shared/utils/pipes';

@Component({
	imports: [HmfAccordionComponent, HomefieldIconLibraryModule, BypassSanitizationPipe],
	selector: 'pdp-tech-specs',
	templateUrl: './tech-specs.component.html',
	styleUrl: './tech-specs.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TechSpecsComponent {
	techSpecs = input<string>();
	isOOSProductSpecs = input(false);

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronRight,
			homefieldIconToolStraighten
		]);
	}
}
